import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { db } from "../../firebase";
import { query, collection, getDocs, orderBy } from "firebase/firestore";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { Add, Done, Error, Refresh } from "@mui/icons-material";
import Modal from "@mui/material/Modal";
import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import { Divider } from "@mui/material";
import PettyForm from "./PettyForm";

const styleMove = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 560,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const PettyCash = () => {
  const [data, setData] = useState([]);

  const [openPetty, setOpenPetty] = useState(false);
  const [updateBank, setUpdateBank] = useState(false);

  const handleClose = () => {
    setOpenPetty(false);
    setUpdateBank(false);
  };

  const [pettyCash, setPettyCash] = useState(0);
  const [loading, setLoading] = useState(true);
  const [id, SetId] = useState("");
  const [date, setDate] = useState("");
  const [amount, setAmount] = useState(0);
  const [description, setDescription] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const ref = collection(db, "pettyCash");
      const q = query(ref, orderBy("date", "desc"));
      const data = await getDocs(q);
      setData(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
      setLoading(false);
    };
    petty();
    fetchData();
  }, []);

  const petty = async () => {
    var sunAmount = 0;
    const ref = collection(db, "pettyCash");
    const querySnapshot = await getDocs(ref);
    querySnapshot.forEach((doc) => {
      sunAmount += Number(doc.data().amount);
    });

    setPettyCash(sunAmount);
  };

  const ModalFunc = (params) => {
    SetId(params[0]);
    setDate(params[1]);
    setDescription(params[2]);
    setAmount(params[3]);
    setUpdateBank(true);
  };

  const handleModalAdd = () => {
    const current = new Date();
    const day = `${current.getDate()}`;
    const month = `${current.getMonth() + 1}`;
    const year = `${current.getFullYear()}`;
    const m = month < 10 ? "0" + month : month;
    const d = day < 10 ? "0" + day : day;
    const date1 = year + "-" + m + "-" + d;

    setDate(date1);

    setAmount(0);
    setDescription("");
    setOpenPetty(true);
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const columns = [
    {
      name: "id", // 0
      label: "id",
      options: {
        display: false,
      },
    },
    {
      name: "date", // 1
      label: "Date",
    },
    {
      name: "description", // 2
      label: "Description",
    },
    {
      name: "amount", // 3
      label: "Amount",
    },
    {
      name: "?",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const row = tableMeta.rowData;

          if (row[3] >= 1)
            return (
              <Tooltip title="OK">
                <Done color="primary" />
              </Tooltip>
            );
          else
            return (
              <Tooltip title="Failing">
                <Error color="error" />
              </Tooltip>
            );
        },
      },
    },

    // Add more columns as needed
  ];
  const AddButton = () => (
    <>
      <Tooltip disableFocusListener title="Add new Record">
        <IconButton onClick={handleModalAdd}>
          <Add />
        </IconButton>
      </Tooltip>
      <Tooltip disableFocusListener title="Refresh DATA">
        <IconButton onClick={handleRefresh}>
          <Refresh />
        </IconButton>
      </Tooltip>

      <IconButton>
        <Typography variant="h6" color="secondary">
          ${Math.round(pettyCash)}
        </Typography>
      </IconButton>
    </>
  );
  const options = {
    customToolbar: AddButton,
    selectableRowsHideCheckboxes: true,
    onRowClick: (rowData) => {
      ModalFunc(rowData);
    },
    sortOrder: {
      name: "title",
      direction: "asc",
    },
  };

  return (
    <>
      {/* ===== BANK NEW REC MODAL ============ */}
      <Modal keepMounted open={openPetty} onClose={handleClose}>
        <Box sx={styleMove}>
          <Divider />
          <PettyForm
            setId={SetId}
            id={id}
            date={date}
            setDate={setDate}
            description={description}
            setDescription={setDescription}
            amount={amount}
            setAmount={setAmount}
            setOpenPetty={setOpenPetty}
            operation="new"
            textButton="SAVE NEW RECORD"
          />
        </Box>
      </Modal>

      {/* ===== BANK UPDATE ============ */}
      <Modal keepMounted open={updateBank} onClose={handleClose}>
        <Box sx={styleMove}>
          <Divider />
          <PettyForm
            setId={SetId}
            id={id}
            date={date}
            setDate={setDate}
            description={description}
            setDescription={setDescription}
            amount={amount}
            setAmount={setAmount}
            setOpenPetty={setOpenPetty}
            operation="update"
            textButton="UPDATE RECORD"
          />
        </Box>
      </Modal>

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "45vh",
            borderRadius: 20,
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <MUIDataTable
          title="Petty Cash"
          columns={columns}
          options={options}
          data={data}
          checkboxSelection
        />
      )}
    </>
  );
};
export default PettyCash;
